import { initOfflineServer, shutdownOfflineServer } from '../server';
import { registerOfflineAppMocks, unregisterOfflineAppMocks } from '../offlineAppMocks';

describe('offline child app mock registration', () => {
  beforeEach(() => {
    shutdownOfflineServer();
    initOfflineServer();
  });

  afterEach(() => {
    shutdownOfflineServer();
  });

  it('adds a child app route to the running Mirage server', () => {
    const registered = registerOfflineAppMocks({
      appId: 'child-app-demo',
      routes: [{
        method: 'get',
        url: '/child-app-demo/api/overview',
        response: { status: 'ok', items: [{ id: 'a' }] },
      }],
    });

    expect(registered).toHaveLength(1);
    expect(window.__offlineDynamicMockRegistry['child-app-demo'][0].url).toBe('/child-app-demo/api/overview');

    const response = registered[0].routeHandler({}, {});
    expect(response.code).toBe(200);
    expect(response.data).toEqual({ status: 'ok', items: [{ id: 'a' }] });
  });

  it('merges child app runtime origins into the Mirage origin list', () => {
    registerOfflineAppMocks({
      appId: 'child-origin-demo',
      routes: [{
        method: 'get',
        url: '/child-origin-demo/api/overview',
        response: { status: 'ok' },
      }],
      origins: ['http://localhost:3000'],
    });

    expect(window.__offlineDynamicMockRegistry.origins).toEqual(expect.arrayContaining(['http://localhost:3000/']));
  });

  it('removes a child app route and its origins when the app unmounts', () => {
    registerOfflineAppMocks({
      appId: 'child-cleanup-demo',
      routes: [{
        method: 'get',
        url: '/child-cleanup-demo/api/overview',
        response: { status: 'ok' },
      }],
      origins: ['http://localhost:3000'],
    });

    expect(window.__offlineDynamicMockRegistry['child-cleanup-demo']).toHaveLength(1);

    const unregistered = unregisterOfflineAppMocks({ appId: 'child-cleanup-demo' });

    expect(unregistered).toEqual({ appId: 'child-cleanup-demo', removed: true });
    expect(window.__offlineDynamicMockRegistry['child-cleanup-demo']).toBeUndefined();
    expect(window.__offlineDynamicMockRegistry.origins).not.toEqual(expect.arrayContaining(['http://localhost:3000/']));
  });
});
